<div class="payment-sip-card" [ngClass]="config?.cardTheme">
  <form [formGroup]="cardForm">
    <div *ngFor="let key of cardConfig?.keys" [ngClass]="cardConfig[key]?.classname">
      <ng-container *ngTemplateOutlet="cardInput; context: { data: cardConfig[key]}"></ng-container>
    </div>
  </form>
</div>

<ng-template #cardInput let-data="data">
  <mat-form-field class="input-field" *ngIf="data?.show" [formGroup]="cardForm" [appearance]="config?.inputAppearance">
    <mat-label>{{data?.label}}</mat-label>
    <input  [formControlName]="data?.control"
            [placeholder]="data?.placeholder"
            [type]="data?.type"
            [prefix]="data?.prefix" [mask]="data?.mask" [dropSpecialCharacters]="data?.dropSpecialCharacters"
            (input)="$event.target.value ? onInputChange($event.target.value, data?.control) : null"
            (blur)="$event.target.value ? onInputBlur($event.target.value, data?.control) : null"
            autocomplete="off" [id]="'card-'+data?.control" matInput />
    <mat-error *ngIf="cardForm.get(data?.control)?.invalid && cardForm.get(data?.control)?.touched && !cardForm.get(data?.control)?.hasError('required')">{{data?.error}}</mat-error>
    <mat-error *ngIf="cardForm.get(data?.control)?.hasError('required') && cardForm.get(data?.control)?.touched">Field required</mat-error>
    <div *ngIf="data?.control==='number'" [ngClass]="card?.card_type" data-bg="/assets/images/payment/sprite-accepted-cards.png"></div>
  </mat-form-field>
</ng-template>